import { VLoadingSpinner } from '../VLoadingSpinner';
import { VStack } from '../VStack';
import { new__cn } from '../util';
import { useFileBrowserContext } from './context';

export const VFileBrowserTreeLoading = () => {
  const { loadingTreeRenderer } = useFileBrowserContext();

  return loadingTreeRenderer ? (
    loadingTreeRenderer()
  ) : (
    <DefaultVFileBrowserTreeLoading />
  );
};

const DefaultVFileBrowserTreeLoading = () => {
  return (
    <VStack
      items="center"
      gap={0.5}
      className={new__cn(
        'h-full min-w-[324px] overflow-auto rounded-md border border-skyBlue-300 px-8 py-6',
      )}
    >
      <VLoadingSpinner className="h-12! w-12! text-Progress-In-Progress!" />

      <VStack items="center" gap={0.5}>
        <div className="text-body-l">Loading...</div>
        <div className="text-body-s">Please wait a moment!</div>
      </VStack>
    </VStack>
  );
};
